<template>
	<div class="">
		<canvas :id="'chart-' + _uid"></canvas>
	</div>
</template>

<script>
	import Chart from 'chart.js';

	export default {
		components:{

		},

		props:[
			'graph_data',
			'disable_duration',
			'sideways'
		],

		data(){
			return {
				to_update: false,
				ctx: null,
			}
		},


		beforeMount(){
			Chart.helpers.drawRoundedTopRectangle = function(ctx, x, y, width, height, radius) {
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				// top right corner
				ctx.lineTo(x + width - radius, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
				// bottom right	corner
				ctx.lineTo(x + width, y + height);
				// bottom left corner
				ctx.lineTo(x, y + height);
				// top left
				ctx.lineTo(x, y + radius);
				ctx.quadraticCurveTo(x, y, x + radius, y);
				ctx.closePath();
			};

			Chart.elements.RoundedTopRectangle = Chart.elements.Rectangle.extend({
				draw: function() {
					var ctx = this._chart.ctx;
					var vm = this._view;
					var left, right, top, bottom, signX, signY, borderSkipped;
					var borderWidth = vm.borderWidth;

					if (!vm.horizontal) {
						// bar
						left = vm.x - vm.width / 2;
						right = vm.x + vm.width / 2;
						top = vm.y;
						bottom = vm.base;
						signX = 1;
						signY = bottom > top? 1: -1;
						borderSkipped = vm.borderSkipped || 'bottom';
					} else {
						// horizontal bar
						left = vm.base;
						right = vm.x;
						top = vm.y - vm.height / 2;
						bottom = vm.y + vm.height / 2;
						signX = right > left? 1: -1;
						signY = 1;
						borderSkipped = vm.borderSkipped || 'left';
					}

					// Canvas doesn't allow us to stroke inside the width so we can
					// adjust the sizes to fit if we're setting a stroke on the line
					if (borderWidth) {
						// borderWidth shold be less than bar width and bar height.
						var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
						borderWidth = borderWidth > barSize? barSize: borderWidth;
						var halfStroke = borderWidth / 2;
						// Adjust borderWidth when bar top position is near vm.base(zero).
						var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
						var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
						var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
						var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
						// not become a vertical line?
						if (borderLeft !== borderRight) {
							top = borderTop;
							bottom = borderBottom;
						}
						// not become a horizontal line?
						if (borderTop !== borderBottom) {
							left = borderLeft;
							right = borderRight;
						}
					}

					// calculate the bar width and roundess
					var barWidth = Math.abs(left - right);
					var roundness = this._chart.config.options.barRoundness || 0.5;
					var radius = barWidth * roundness * 0.5;

					// keep track of the original top of the bar
					var prevTop = top;

					// move the top down so there is room to draw the rounded top
					top = prevTop + radius;
					var barRadius = top - prevTop;

					ctx.beginPath();
					ctx.fillStyle = vm.backgroundColor;
					ctx.strokeStyle = vm.borderColor;
					ctx.lineWidth = borderWidth;

					// draw the rounded top rectangle
					Chart.helpers.drawRoundedTopRectangle(ctx, left, (top - barRadius + 1), barWidth, bottom - prevTop, barRadius);

					ctx.fill();
					if (borderWidth) {
						ctx.stroke();
					}

					// restore the original top value so tooltips and scales still work
					top = prevTop;
				},
			});

			Chart.defaults.roundedBar = Chart.helpers.clone(Chart.defaults.bar);

			Chart.controllers.roundedBar = Chart.controllers.bar.extend({
				dataElementType: Chart.elements.RoundedTopRectangle
			});
		},

		mounted() {
			this.loadGraph();
		},

		methods: {
			loadGraph(){
				if (typeof(this.graph_data) === 'undefined' || !this.graph_data){
					return;
				}

				let
					avg_data = [],
					min_data = [],
					max_data = [],
					one_bar = false,
					data = [],
					colors = [];

				this.ctx = document.getElementById('chart-' + this._uid).getContext('2d');

				this.graph_data.forEach(function (month){
					if (month.length){
						min_data.push(month[0]);
						max_data.push(month[1]);
						avg_data.push(month[2]);
					}
					else {
						let color = 'rgb(235, 50, 138, .7)';

						if (month < 70){
							color = 'rgba(214, 175, 128, 0.7)';
						}
						else if (month < 80){
							color = 'rgb(255, 195, 75, .7)';
						}

						avg_data.push(month);
						colors.push(color);
						one_bar = true;
					}
				});

				if (!one_bar){
					data = [
						{
							type: 'line',
							label: 'Average',
							borderColor: 'rgb(138, 151, 114)',
							pointBackgroundColor: 'rgb(255, 255, 255)',
							borderWidth: 2,
							fill: false,
							tension: 0,
							data: avg_data
						},
						{
							label: 'Min',
							data: min_data,
							backgroundColor: 'rgba(138, 152, 114, 0.7)',
							radius: 2,
							borderWidth: 0
						},
						{
							label: 'Max',
							data: max_data,
							backgroundColor: 'rgba(138, 152, 114, 0.7)',
							radius: 2,
							borderWidth: 0
						},
					]
				}
				else {
					data = [
						{
							label: 'Score',
							data: avg_data,
							backgroundColor: colors,
							radius: 2,
							borderWidth: 0
						}
					]
				}

				let _scales;

				if (this.sideways){
					_scales = {
						xAxes: [{
							ticks: {
								beginAtZero:true,

							},
							gridLines: {
								borderDash: [8, 4],
								drawBorder: false
							}
						}],
						yAxes: [{
							barPercentage: 0.4,
							categoryPercentage: 0.5,
							gridLines: {
								display:false
							}
						}]
					};
				}
				else {
					_scales = {
						yAxes: [{
							ticks: {
								beginAtZero:true,

							},
							gridLines: {
								borderDash: [8, 4],
								drawBorder: false
							}
						}],
						xAxes: [{
							barPercentage: 0.4,
							categoryPercentage: 0.5,
							gridLines: {
								display:false
							}
						}]
					};
				}


				new Chart(this.ctx, {
					type: this.sideways ? 'horizontalBar' : 'roundedBar',
					plugins: [this.createChartPlugin()],
					data: {
						labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
						datasets: data
					},
					options: {
						legend: {
							display: false
						},
						animation: {
							duration: this.disable_duration ? 1 : 1000
						},
						maintainAspectRatio: false,
						responsive: true,
						barRoundness: 1,
						scales: _scales
					}
				});
			},

			createChartPlugin(){
				let _this = this;

				return {
					id: 'export_png_data',

					beforeDraw : function(chart, options){
						if (_this.to_update)
							return;

						_this.$emit('update_graph_image', null);
						_this.to_update = true;
					},

					afterRender: function(chart, options) {
						if (!_this.to_update)
							return;

						if (document.getElementById(_this.ctx.canvas.id)){
							_this.$emit('update_graph_image', _this.ctx.canvas.toDataURL('image/png', 0.2));
							_this.to_update = false;
						}
					}
				};
			}
		},

		watch: {
			'graph_data'() {
				this.loadGraph();
			}
		}
	}
</script>
